module.exports = __webpack_public_path__ + "img/PLAN BEKAERT.546b5927.jpg";